const { loadContext, loadEntries, loadGroups } = require('./loaders');

const loadServices = () => {
    loadContext(require.context('@/js/services', true));
};

const loadBaseModules = () => {
    loadEntries([
        () => require('@/js/wisemetering/extensions.js'),
        () => require('@/js/wisemetering/init.js'),
        () => require('@/js/wisemetering/utils.js'),
        () => require('@/js/wisemetering/analytics.js'),
        () => require('@/js/wisemetering/permissions.js'),
        () => require('@/js/wisemetering/icons.js'),
        () => require('@/js/wisemetering/number_formatter.js')
    ]);
};

const loadModelModules = () => {
    loadEntries([
        () => require('@/js/wisemetering/actuator_kinds/model.js'),
        () => require('@/js/wisemetering/actuators/model.js'),
        () => require('@/js/wisemetering/addresses/model.js'),
        () => require('@/js/wisemetering/alarms/model.js'),
        () => require('@/js/wisemetering/allocations/model.js'),
        () => require('@/js/wisemetering/analyze_views/model.js'),
        () => require('@/js/wisemetering/site_tags/model.js'),
        () => require('@/js/wisemetering/sites/model.js'),
        () => require('@/js/wisemetering/circuit_tags/model.js'),
        () => require('@/js/wisemetering/circuits/model.js'),
        () => require('@/js/wisemetering/contracts/model.js'),
        () => require('@/js/wisemetering/companies/model.js'),
        () => require('@/js/wisemetering/devices/model.js'),
        () => require('@/js/wisemetering/events/model.js'),
        () => require('@/js/wisemetering/etls/model.js'),
        () => require('@/js/wisemetering/external_assets/model.js'),
        () => require('@/js/wisemetering/folders/model.js'),
        () => require('@/js/wisemetering/global_report_types/model.js'),
        () => require('@/js/wisemetering/groups/model.js'),
        () => require('@/js/wisemetering/holidays/model.js'),
        () => require('@/js/wisemetering/indicators/model.js'),
        () => require('@/js/wisemetering/invoices/model.js'),
        () => require('@/js/wisemetering/integration_configurations/model.js'),
        () => require('@/js/wisemetering/integration_licenses/model.js'),
        () => require('@/js/wisemetering/integration_license_logs/model.js'),
        () => require('@/js/wisemetering/integration_partners/model.js'),
        () => require('@/js/wisemetering/integrations/model.js'),
        () => require('@/js/wisemetering/leads/model.js'),
        () => require('@/js/wisemetering/markers/model.js'),
        () => require('@/js/wisemetering/notifications/model.js'),
        () => require('@/js/wisemetering/objectives/model.js'),
        () => require('@/js/wisemetering/opportunities/model.js'),
        () => require('@/js/wisemetering/organizations/model.js'),
        () => require('@/js/wisemetering/organization_logs/model.js'),
        () => require('@/js/wisemetering/packages/model.js'),
        () => require('@/js/wisemetering/reports/model.js'),
        () => require('@/js/wisemetering/root_objects/model.js'),
        () => require('@/js/wisemetering/site_documents/model.js'),
        () => require('@/js/wisemetering/seus/model.js'),
        () => require('@/js/wisemetering/scheduled_reports/model.js'),
        () => require('@/js/wisemetering/site_packages/model.js'),
        () => require('@/js/wisemetering/tariffs/model.js'),
        () => require('@/js/wisemetering/tariff_types/model.js'),
        () => require('@/js/wisemetering/tars/model.js'),
        () => require('@/js/wisemetering/tenants/model.js'),
        () => require('@/js/wisemetering/tenant_invoices/model.js'),
        () => require('@/js/wisemetering/plans/model.js'),
        () => require('@/js/wisemetering/users/model.js'),
        () => require('@/js/wisemetering/user_preferences/model.js'),
        () => require('@/js/wisemetering/utilities/model.js'),
        () => require('@/js/wisemetering/utility_kinds/model.js'),
        () => require('@/js/wisemetering/zone_attribute_values/model.js'),
        () => require('@/js/wisemetering/zone_attributes/model.js'),
        () => require('@/js/wisemetering/zone_report_types/model.js'),
        () => require('@/js/wisemetering/zones/model.js')
    ]);
};

const loadCollectionModules = () => {
    loadEntries([
        () => require('@/js/wisemetering/actuator_kinds/collection.js'),
        () => require('@/js/wisemetering/actuators/collection.js'),
        () => require('@/js/wisemetering/alarms/collection.js'),
        () => require('@/js/wisemetering/allocations/collection.js'),
        () => require('@/js/wisemetering/analyze_views/collection.js'),
        () => require('@/js/wisemetering/api_requests/collection.js'),
        () => require('@/js/wisemetering/site_tags/collection.js'),
        () => require('@/js/wisemetering/circuit_tags/collection.js'),
        () => require('@/js/wisemetering/circuits/collection.js'),
        () => require('@/js/wisemetering/contracts/collection.js'),
        () => require('@/js/wisemetering/companies/collection.js'),
        () => require('@/js/wisemetering/devices/collection.js'),
        () => require('@/js/wisemetering/events/collection.js'),
        () => require('@/js/wisemetering/etls/collection.js'),
        () => require('@/js/wisemetering/external_assets/collection.js'),
        () => require('@/js/wisemetering/folders/collection.js'),
        () => require('@/js/wisemetering/global_report_types/collection.js'),
        () => require('@/js/wisemetering/groups/collection.js'),
        () => require('@/js/wisemetering/holidays/collection.js'),
        () => require('@/js/wisemetering/indicators/collection.js'),
        () => require('@/js/wisemetering/integration_configurations/collection.js'),
        () => require('@/js/wisemetering/integration_licenses/collection.js'),
        () => require('@/js/wisemetering/integration_license_logs/collection.js'),
        () => require('@/js/wisemetering/integration_partners/collection.js'),
        () => require('@/js/wisemetering/integrations/collection.js'),
        () => require('@/js/wisemetering/invoices/collection.js'),
        () => require('@/js/wisemetering/leads/collection.js'),
        () => require('@/js/wisemetering/markers/collection.js'),
        () => require('@/js/wisemetering/notifications/collection.js'),
        () => require('@/js/wisemetering/objectives/collection.js'),
        () => require('@/js/wisemetering/opportunities/collection.js'),
        () => require('@/js/wisemetering/organization_logs/collection.js'),
        () => require('@/js/wisemetering/packages/collection.js'),
        () => require('@/js/wisemetering/reports/collection.js'),
        () => require('@/js/wisemetering/root_objects/collection.js'),
        () => require('@/js/wisemetering/seus/collection.js'),
        () => require('@/js/wisemetering/scheduled_reports/collection.js'),
        () => require('@/js/wisemetering/site_documents/collection.js'),
        () => require('@/js/wisemetering/site_packages/collection.js'),
        () => require('@/js/wisemetering/tariffs/collection.js'),
        () => require('@/js/wisemetering/tariff_types/collection.js'),
        () => require('@/js/wisemetering/tars/collection.js'),
        () => require('@/js/wisemetering/tenants/collection.js'),
        () => require('@/js/wisemetering/tenant_invoices/collection.js'),
        () => require('@/js/wisemetering/plans/collection.js'),
        () => require('@/js/wisemetering/users/collection.js'),
        () => require('@/js/wisemetering/utilities/collection.js'),
        () => require('@/js/wisemetering/utility_kinds/collection.js'),
        () => require('@/js/wisemetering/zone_attribute_values/collection.js'),
        () => require('@/js/wisemetering/zone_attributes/collection.js'),
        () => require('@/js/wisemetering/zone_report_types/collection.js'),
        () => require('@/js/wisemetering/zones/collection.js')
    ]);
};

const loadTemplateModules = () => {
    require('../templates');
};

const loadUiModules = () => {
    loadEntries([
        () => require('@/js/wisemetering/ui/cards_view.js'),
        () => require('@/js/wisemetering/ui/charts/scatter.js'),
        () => require('@/js/wisemetering/ui/crud/base.js'),
        () => require('@/js/wisemetering/ui/crud/save.js'),
        () => require('@/js/wisemetering/ui/custom_dashboard.js'),
        () => require('@/js/wisemetering/ui/layouts/design-system.js'),
        () => require('@/js/wisemetering/ui/layouts/login.js'),
        () => require('@/js/wisemetering/ui/layouts/signup.js'),
        () => require('@/js/wisemetering/ui/layouts/root.js'),
        () => require('@/js/wisemetering/ui/tipper.js'),
        () => require('@/js/wisemetering/ui/content.js'),
        () => require('@/js/wisemetering/ui/node.js'),
        () => require('@/js/wisemetering/ui/sites.js'),
        () => require('@/js/wisemetering/ui/costs.js'),
        () => require('@/js/wisemetering/ui/global_dashboard.js'),
        () => require('@/js/wisemetering/ui/global_dashboard_header.js'),
        () => require('@/js/wisemetering/ui/modal/base.js'),
        () => require('@/js/wisemetering/ui/modal/custom.js'),
        () => require('@/js/wisemetering/ui/modal/destroy.js'),
        () => require('@/js/wisemetering/ui/modal/destroy_extra_confirmation.js'),
        () => require('@/js/wisemetering/ui/modal/save.js'),
        () => require('@/js/wisemetering/ui/modal/show.js'),
        () => require('@/js/wisemetering/ui/modal/loading.js'),
        () => require('@/js/wisemetering/ui/upload_data.js'),
        () => require('@/js/wisemetering/ui/map/site_popup.js'),
        () => require('@/js/wisemetering/ui/map/index.js'),
        () => require('@/js/wisemetering/ui/map/search.js'),
        () => require('@/js/wisemetering/ui/map/styles.js'),
        () => require('@/js/wisemetering/ui/no_access/no_access.js'),
        () => require('@/js/wisemetering/ui/option/view.js'),
        () => require('@/js/wisemetering/ui/schedule/base.js'),
        () => require('@/js/wisemetering/ui/schedule/circuit_schedule.js'),
        () => require('@/js/wisemetering/ui/select/view.js'),
        () => require('@/js/wisemetering/ui/table/index.js'),
        () => require('@/js/wisemetering/ui/table/view.js'),
        () => require('@/js/wisemetering/ui/table/delete_all.js'),
        () => require('@/js/wisemetering/ui/table/generate.js'),
        () => require('@/js/wisemetering/ui/card/index.js'),
        () => require('@/js/wisemetering/ui/card/item.js'),
        () => require('@/js/wisemetering/ui/card/container.js'),
        () => require('@/js/wisemetering/ui/widget/base.js'),
        () => require('@/js/wisemetering/ui/widget/co2_displayer.js'),
        () => require('@/js/wisemetering/ui/widget/bar_chart.js'),
        () => require('@/js/wisemetering/ui/widget/benchmark.js'),
        () => require('@/js/wisemetering/ui/widget/bubble_chart.js'),
        () => require('@/js/wisemetering/ui/widget/carousel_pie.js'),
        () => require('@/js/wisemetering/ui/widget/cost.js'),
        () => require('@/js/wisemetering/ui/widget/dashboard_map.js'),
        () => require('@/js/wisemetering/ui/widget/distribution.js'),
        () => require('@/js/wisemetering/ui/widget/global_objectives.js'),
        () => require('@/js/wisemetering/ui/widget/no_data.js'),
        () => require('@/js/wisemetering/ui/widget/number_displayer.js'),
        () => require('@/js/wisemetering/ui/widget/objective.js'),
        () => require('@/js/wisemetering/ui/widget/omie.js'),
        () => require('@/js/wisemetering/ui/widget/pie_chart.js'),
        () => require('@/js/wisemetering/ui/widget/power.js'),
        () => require('@/js/wisemetering/ui/widget/table.js'),
        () => require('@/js/wisemetering/ui/widget/trend.js'),
        () => require('@/js/wisemetering/ui/widget/value_displayer.js'),
        () => require('@/js/wisemetering/ui/widget/widget_options.js'),
        () => require('@/js/wisemetering/ui/system_info_accordion.js')
    ]);
};

const eagerFeatureViewLoaders = {};

const alarmsRoutesImport = () => import(/* webpackChunkName: "feature-alarms-routes" */ './features/alarms-routes');
const etlsRoutesImport = () => import(/* webpackChunkName: "feature-etls-routes" */ './features/etls-routes');
const indicatorsRoutesImport = () => import(/* webpackChunkName: "feature-indicators-routes" */ './features/indicators-routes');
const integrationsRoutesImport = () => import(/* webpackChunkName: "feature-integrations-routes" */ './features/integrations-routes');
const organizationsRoutesImport = () => import(/* webpackChunkName: "feature-organizations-routes" */ './features/organizations-routes');
const reportsRoutesImport = () => import(/* webpackChunkName: "feature-reports-routes" */ './features/reports-routes');
const standaloneRoutesImport = () => import(/* webpackChunkName: "feature-standalone-routes" */ './features/standalone-routes');
const tariffsRoutesImport = () => import(/* webpackChunkName: "feature-tariffs-routes" */ './features/tariffs-routes');
const tenantsRoutesImport = () => import(/* webpackChunkName: "feature-tenants-routes" */ './features/tenants-routes');
const treeRoutesImport = () => import(/* webpackChunkName: "feature-tree-routes" */ './features/tree-routes');
const utilitiesRoutesImport = () => import(/* webpackChunkName: "feature-utilities-routes" */ './features/utilities-routes');
const zonesRoutesImport = () => import(/* webpackChunkName: "feature-zones-routes" */ './features/zones-routes');

const lazyFeatureViewImporters = {
    actuators: treeRoutesImport,
    admin: standaloneRoutesImport,
    alarms: alarmsRoutesImport,
    allocations: tenantsRoutesImport,
    apiKeys: standaloneRoutesImport,
    apiRequests: standaloneRoutesImport,
    chat: standaloneRoutesImport,
    circuitTags: standaloneRoutesImport,
    circuits: treeRoutesImport,
    companies: standaloneRoutesImport,
    contracts: treeRoutesImport,
    devices: standaloneRoutesImport,
    etls: etlsRoutesImport,
    events: standaloneRoutesImport,
    folders: treeRoutesImport,
    groups: standaloneRoutesImport,
    holidays: standaloneRoutesImport,
    indicators: indicatorsRoutesImport,
    invoices: utilitiesRoutesImport,
    integrationConfigurations: integrationsRoutesImport,
    integrationLicenses: integrationsRoutesImport,
    integrationPartners: integrationsRoutesImport,
    integrations: integrationsRoutesImport,
    leads: standaloneRoutesImport,
    markers: treeRoutesImport,
    notifications: standaloneRoutesImport,
    objectives: indicatorsRoutesImport,
    opportunities: zonesRoutesImport,
    organizationLogs: organizationsRoutesImport,
    organizations: organizationsRoutesImport,
    readings: treeRoutesImport,
    reports: reportsRoutesImport,
    rootObjects: utilitiesRoutesImport,
    scheduledReports: reportsRoutesImport,
    seus: treeRoutesImport,
    siteDocuments: zonesRoutesImport,
    siteTags: standaloneRoutesImport,
    sites: organizationsRoutesImport,
    tariffs: tariffsRoutesImport,
    tars: tariffsRoutesImport,
    tenantInvoices: tenantsRoutesImport,
    tenants: tenantsRoutesImport,
    users: standaloneRoutesImport,
    utilities: utilitiesRoutesImport,
    zoneAttributes: treeRoutesImport,
    zones: zonesRoutesImport
};
const loadedFeatureViews = new Set();

const markFeatureViewsLoaded = (featureNames) => {
    featureNames.forEach((featureName) => loadedFeatureViews.add(featureName));
};

const loadFeatureViewModules = () => {
    loadGroups(eagerFeatureViewLoaders);
    markFeatureViewsLoaded(Object.keys(eagerFeatureViewLoaders));
};

const ensureFeatureViewsLoaded = async (featureNames = []) => {
    const pendingFeatureNames = [...new Set(featureNames)].filter((featureName) => !loadedFeatureViews.has(featureName));

    if (pendingFeatureNames.length === 0) {
        return;
    }

    const pendingImports = new Map();

    pendingFeatureNames.forEach((featureName) => {
        const eagerLoader = eagerFeatureViewLoaders[featureName];
        if (eagerLoader) {
            eagerLoader();
            markFeatureViewsLoaded([featureName]);
            return;
        }

        const lazyImporter = lazyFeatureViewImporters[featureName];
        if (!lazyImporter) {
            throw new Error(`Unknown feature view loader: ${featureName}`);
        }

        if (!pendingImports.has(lazyImporter)) {
            pendingImports.set(lazyImporter, []);
        }

        pendingImports.get(lazyImporter).push(featureName);
    });

    await Promise.all(
        [...pendingImports.entries()].map(async ([lazyImporter, importerFeatureNames]) => {
            await lazyImporter();
            markFeatureViewsLoaded(importerFeatureNames);
        })
    );
};

const loadStartupModules = () => {
    loadEntries([
        () => require('@/js/wisemetering/controller.js'),
        () => require('@/js/wisemetering/router.js'),
        () => require('@/js/wisemetering/glue.js')
    ]);
};

module.exports = {
    ensureFeatureViewsLoaded,
    loadBaseModules,
    loadCollectionModules,
    loadFeatureViewModules,
    loadModelModules,
    loadServices,
    loadStartupModules,
    loadTemplateModules,
    loadUiModules
};
